export const overlijdenMeldenEn = {
  OverlijdenMeldenFormulierStapGegevensOverledene: "Personal details deceased"
};
